var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "share" }, [
    _c("div", { staticClass: "title" }, [_vm._v("分享")]),
    _vm._v(" "),
    _c("ul", [
      _c("li", { staticClass: "weixin" }, [
        _c("a", { ref: "wxRef", attrs: { href: "javascript:void(0)" } }, [
          _c("em", { staticClass: "icon weixin-icon" }),
          _c("span", { staticClass: "label" }, [_vm._v("微信分享")]),
        ]),
        _vm._v(" "),
        _vm._m(0),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "sinat" }, [
        _c(
          "a",
          {
            attrs: {
              "data-clev": "10220259",
              target: "_blank",
              href: _vm.sina_url,
              "data-spm-acode": _vm.shareAction,
              "data-spm-click-pm": "shareCode:weibo",
            },
          },
          [
            _c("em", { staticClass: "icon sinat-icon" }),
            _vm._v(" "),
            _c("span", { staticClass: "label" }, [_vm._v("新浪微博")]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "qzone" }, [
        _c(
          "a",
          {
            attrs: {
              "data-clev": "10220260",
              target: "_blank",
              href: _vm.qzone_url,
              "data-spm-acode": _vm.shareAction,
              "data-spm-click-pm": "shareCode:qqz",
            },
          },
          [
            _c("em", { staticClass: "icon qzone-icon" }),
            _vm._v(" "),
            _c("span", { staticClass: "label" }),
            _vm._v("QQ空间\n            "),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "copy-link",
          on: {
            click: _vm.copy,
            "~mouseenter": function ($event) {
              _vm.copy($event)
            },
          },
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: "javascript:void(0)",
                "data-spm-acode": _vm.shareAction,
                "data-spm-click-pm": "shareCode:link",
              },
            },
            [
              _c("em", { staticClass: "icon link-icon" }),
              _c("span", { staticClass: "label" }, [_vm._v("复制链接")]),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showToast,
            expression: "showToast",
          },
        ],
        staticClass: "toast",
      },
      [_c("div", { staticClass: "toast-text" }, [_vm._v("链接复制成功")])]
    ),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wx-code" }, [
      _c("div", { staticClass: "cort" }),
      _vm._v(" "),
      _c("div", { staticClass: "code-pic" }, [
        _c("div", { staticClass: "qrcode", attrs: { id: "qrcode" } }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "phone-scan" }, [
      _c("div", { staticClass: "qr-image", attrs: { id: "browseInPhone" } }, [
        _c("div", { staticClass: "sohu-logo" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text1" }, [
        _c("span", [_vm._v("扫码打开")]),
        _vm._v(" "),
        _c("span", { staticClass: "border-font" }, [_vm._v("手机搜狐网")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text2" }, [
        _c("div", [_vm._v("无需下载APP")]),
        _vm._v(" "),
        _c("div", [_vm._v("精彩内容随时看")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }